import { Button, Callout, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import { set, get } from 'es-cookie'
import { useBooleanValue } from '../hooks/useBooleanValue'

// TODO: refactor this to allow different types of announcements and Hide duration variability
export default () => {
  const ANNOUNCEMENT_BANNER_HIDDEN_KEY = 'ANNOUNCEMENT_BANNER_HIDDEN_KEY'

  const [announcementBanner, { toggleValue: toggleAnnouncementBanner }] = useBooleanValue(false, {
    storageKey: ANNOUNCEMENT_BANNER_HIDDEN_KEY,
    userScoped: true
  })

  const hideAnnouncements = () => {
    toggleAnnouncementBanner()
    const fortyEightHoursFromNow = new Date()
    fortyEightHoursFromNow.setHours(fortyEightHoursFromNow.getHours() + 48)
    set(ANNOUNCEMENT_BANNER_HIDDEN_KEY, 'true', { expires: fortyEightHoursFromNow })
  }

  if (announcementBanner) {
    if (get(ANNOUNCEMENT_BANNER_HIDDEN_KEY) === 'true') {
      return null
    }

    toggleAnnouncementBanner()
  }

  return (
    <>
      <Callout icon={IconNames.STAR} intent={Intent.PRIMARY} className="screen-only">
        <p style={{ textAlign: 'center', marginBottom: 0 }}>
          Scale your e-commerce business at the{' '}
          <a
            style={{ color: '#106ba3', fontWeight: 'bold' }}
            href="https://marketing.uprightlabs.com/userconference2024/"
            target="_blank"
            rel="noreferrer"
          >
            2024 Neatoscan & Upright Labs User Conference!
          </a>
          &nbsp;&nbsp;&nbsp;
          <a href="https://marketing.uprightlabs.com/userconference2024/" target="_blank" rel="noreferrer">
            <Button intent={Intent.SUCCESS}>Learn More</Button>
          </a>
          <span style={{ float: 'right' }}>
            <Button
              minimal
              icon={IconNames.CROSS}
              style={{ color: 'rgb(92, 112, 128)' }}
              onClick={() => hideAnnouncements()}
            >
              Hide
            </Button>
          </span>
        </p>
      </Callout>
    </>
  )
}
